import * as React from 'react'
import { FunctionComponent } from 'react'

const Templates: FunctionComponent = () => {
    return <>Templates</>
}

export default Templates
